import axiosInstance from '../../../lib/axios';

export const adminService = {
  // Récupérer la liste des administrateurs
  getAdmins: async ({ page = 1, search = '' } = {}) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page.toString());
    if (search) params.append('search', search);
    
    const response = await axiosInstance.get(`/api/v1/admin/admins?${params.toString()}`);
    return response.data;
  },

  // Créer un nouvel administrateur
  createAdmin: async (adminData) => {
    const response = await axiosInstance.post('/api/v1/admin/admins', adminData);
    return response.data;
  },

  // Récupérer un administrateur par ID
  getAdmin: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/admins/${id}`);
    return response.data;
  },

  // Mettre à jour un administrateur
  updateAdmin: async (id, adminData) => {
    const response = await axiosInstance.put(`/api/v1/admin/admins/${id}`, adminData);
    return response.data;
  },

  // Réinitialiser le mot de passe d'un administrateur
  resetAdminPassword: async (id, passwordData) => {
    const response = await axiosInstance.put(`/api/v1/admin/admins/${id}/reset-password`, passwordData);
    return response.data;
  }
};